// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--Oz4uo","notification":"_93444fe79c--notification--XYg_h","control":"_93444fe79c--control--GSsKt"};